import { render, staticRenderFns } from "./FmxContact.vue?vue&type=template&id=32d52e5a&"
import script from "./FmxContact.vue?vue&type=script&lang=js&"
export * from "./FmxContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports